export default "__VITE_ASSET__DHjsQ0pI__"